import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import React from 'react';
import { createTheme } from '@mui/material/styles';
import {
  componentsOverrides,
  selectedLocale,
} from '../../../theme/ThemeProviderWithTheme';

export const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#d94d15',
      },
      secondary: {
        // Nav color
        main: '#000000',
      },
    },
    components: componentsOverrides,
  },
  selectedLocale.muiCore,
  selectedLocale.muiDatePicker,
  selectedLocale.muiDataGrid
);

export default function ThemeProviderWithTheme({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}
